/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { PianoModal } from './customBlocks/pianoModal';

// ------------------------------ SALIDAS -------------------------------------

Blockly.Blocks.ARDUINOUNO_salidas_led = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON || 'ON', 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF || 'OFF', 'LOW'],
      ]), 'STAT');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_NEW)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'led',
};

Blockly.Blocks.ARDUINOUNO_salidas_led_brillo = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('DATOIN')
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_INTENSIDAD);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_PWM)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'led',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_piezo_buzzer_piano = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Zumbador.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO);
    this.appendDummyInput()
      .appendField(new PianoModal({ basePitch: 165, octave: 3, duration: 1000, pinName: 'NPIN' }, undefined, {}), 'PIANO');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'buzzer',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_piezo_buzzer_variable = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Zumbador.png`, options.blockWidth, options.blockHeight));
    this.appendValueInput('VAR')
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO)
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TONE_LC);
    this.appendValueInput('DURATION')
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZER_DURATION);
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
  getPins: function () { return ['NPIN']; },
  component: 'buzzer',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_piezo_buzzerno = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Zumbador.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZERNO)
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
  getPins: function () { return ['NPIN']; },
  component: 'buzzer',
};

Blockly.Blocks.ARDUINOUNO_salidas_zumbador_activo = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Zumbador_Activo.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON || 'ON', 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF || 'OFF', 'LOW'],
      ]), 'STAT');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_ZUMBADOR_ACTIVO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_ZUMBADOR_ACTIVO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'zumbador',
};

Blockly.Blocks.ARDUINOUNO_salidas_laser = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Laser.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON || 'ON', 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF || 'OFF', 'LOW'],
      ]), 'STAT');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LASER)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LASER_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'laser',
};

Blockly.Blocks.ARDUINOUNO_salidas_led_bicolor = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led_bicolor.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_BICOLOR_ELEGIR)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LEDRGB_ROJO, 'red'],
        [Blockly.Msg.LANG_SALIDAS_LEDRGB_AMARILLO, 'yellow'],
        [Blockly.Msg.LANG_SALIDAS_LEDRGB_NARANJA, 'orange'],
      ]), 'STAT');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_BICOLOR_PIN_R)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_BICOLOR_PIN_Y)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_BICOLOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN', 'NPIN2']; },
  component: 'led_bicolor',
};

Blockly.Blocks.ARDUINOUNO_salidas_led_bicolor_apagar = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led_bicolor.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_BICOLOR_APAGAR)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_BICOLOR_PIN_Y)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_BICOLOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN', 'NPIN2']; },
  component: 'led_bicolor',
};

Blockly.Blocks.ARDUINOUNO_salidas_ledRGB = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led_rgb.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_SALIDAS_LEDRGB_UNOMEGA);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LEDRGB_UNOMEGA_PIN_R)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LEDRGB_UNOMEGA_PIN_G)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LEDRGB_UNOMEGA_PIN_B)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_NPIN3`),
      ), 'NPIN3');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_UNOMEGA_TOOLTIP);
  },
  getPins: function () { return ['NPIN', 'NPIN2', 'NPIN3']; },
  component: 'ledRGB',
};

Blockly.Blocks.ARDUINOUNO_salidas_rele = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Rele.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON || 'ON', 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF || 'OFF', 'LOW'],
      ]), 'STAT');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_RELE_UNOMEGA)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_RELE_UNOMEGA_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'rele',
};

// ------------------------- ENTRADAS DIGITALES -------------------------------

Blockly.Blocks.ARDUINOUNO_ENTRADAS_button = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Boton.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_BUTTON_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_BUTTON_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'button',
};

Blockly.Blocks.ARDUINOUNO_entradas_ultrasonido = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Ultrasonido.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO);
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_TRIGGER_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN1`),
      ), 'NPIN1');
    this.appendDummyInput('PIN2')
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_ECHO_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.setInputsInline(true);
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_TOOLTIP);
  },
  getPins: function () { return ['NPIN1', 'NPIN2']; },
  component: 'ultrasonic',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_button_touch = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Sensor_tactil2.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_TOUCH)
      .appendField(Blockly.Msg.LANG_ENTRADAS_TOUCH_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_TOUCH_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'button',
};

Blockly.Blocks.ARDUINOUNO_SALIDAS_read_dht11 = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Dht11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ENTRADAS_HUMEDAD, 'H'],
        [Blockly.Msg.LANG_ENTRADAS_TEMPERATURA, 'T'],
      ]), 'TYPE');
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_DHT11_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_READ_DHT11_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'dht11',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_obstaculo = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Obstaculo.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_OBSTACULO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_OBSTACULO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'obstacle',
};

Blockly.Blocks.ARDUINOUNO_entradas_hall = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Magnetico.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_HALL)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_HALL_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'hall',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_infrared = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Optico.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_INFRARED)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_INFRARED_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'infrared',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_temperature = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/56.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_DS18B20_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_TEMPERATURA_DS18B20_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'temperature',
};

Blockly.Blocks.ARDUINOUNO_SALIDAS_IR = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Sensor_IR.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_IR)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_IRCONTROL2)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Control_IR.png`, 62 * options.zoom, 114 * options.zoom))
      .appendField(Blockly.Msg.LANG_ENTRADAS_IRCONTROL2_PIN)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_PIN13 || '1', '16738455'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN12 || '2', '16750695'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN11 || '3', '16756815'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN10 || '4', '16724175'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN9 || '5', '16718055'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN8 || '6', '16743045'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN7 || '7', '16716015'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN6 || '8', '16726215'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN5 || '9', '16734885'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN4 || '0', '16730805'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN3 || 'OK', '16712445'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN2 || '*', '16728765'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN1 || '#', '16732845'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN0 || '←', '16720605'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN14 || '↑', '16736925'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN15 || '→', '16761405'],
        [Blockly.Msg.LANG_SALIDAS_LED_PIN16 || '↓', '16754775'],
      ]), 'NUM');
    this.setOutput(true, 'Boolean');
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_IR_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'infrared',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_VIBRATION = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Vibracion2.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_VIBRATION)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_VIBRATION_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'vibration',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_TILT = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Inclinacion.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_TILT)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_TILT_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'tilt',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_CHOQUE = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Choque.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_CHOQUE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_CHOQUE_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'choque',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_follower = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_FOLLOWER)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Seguidor_de_linea.png`, options.blockWidth, options.blockHeight));
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_ENTRADAS_FOLLOWER_PIN_LEFT)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput('PIN2')
      .appendField(Blockly.Msg.LANG_ENTRADAS_FOLLOWER_PIN_RIGHT)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.appendStatementInput('SENS1').appendField(Blockly.Msg.LANG_ENTRADAS_FOLLOWER_LEFT);
    this.appendStatementInput('SENS2').appendField(Blockly.Msg.LANG_ENTRADAS_FOLLOWER_RIGHT);
    this.appendStatementInput('SENS3').appendField(Blockly.Msg.LANG_ENTRADAS_FOLLOWER_NINGUNO);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_FOLLOWER_TOOLTIP);
  },
  getPins: function () { return ['NPIN', 'NPIN2']; },
  component: 'follower',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_GOLPE = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Golpe.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_GOLPE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_GOLPE_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'golpe',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_INTERRUPTOR_OPTICO = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Interruptor_optico.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_INTERRUPTOR_OPTICO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_INTERRUPTOR_OPTICO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'optico',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_ENCODER = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Rotacion.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_ENCODER)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN')
      .appendField(Blockly.Msg.LANG_ENTRADAS_ENCODER_CLK)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_ENCODER_TOOLTIP);
  },
  getPins: function () { return ['NPIN', 'NPIN2']; },
  component: 'encoder',
};

// ------------------------ ENTRADAS ANALOGICAS -------------------------------

Blockly.Blocks.ARDUINOUNO_entradas_suelo = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Suelo.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_SUELO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_SUELO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'soil',
};

Blockly.Blocks.ARDUINOUNO_entradas_lluvia = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Lluvia.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_LLUVIA)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_LLUVIA_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'rain',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_potentiometer = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Pote.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_POTENTIOMETER)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(false);
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_POTENTIOMETER_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'potentiometer',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_photoresistor = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Ldr.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_PHOTORESISTOR)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_PHOTORESISTOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'photoresistor',
};

Blockly.Blocks.ARDUINOUNO_entradas_sonido = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Sonido.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_SONIDO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_SONIDO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'sound',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_FUEGO = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Fuego.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_FUEGO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_FUEGO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'fuego',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_TEMPERATURA = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Temperatura.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_TEMPERATURA_ANALOGICO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_TEMPERATURA_ANALOGICO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'temperatura',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_JOYSTICK = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Joystick.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ENTRADAS_JOYSTICK_X, 'x'],
        [Blockly.Msg.LANG_ENTRADAS_JOYSTICK_Y, 'y'],
        [Blockly.Msg.LANG_ENTRADAS_JOYSTICK_A, 'a'],
      ]), 'NPIN');
    this.appendDummyInput('PINS')
      .appendField(Blockly.Msg.LANG_ENTRADAS_JOYSTICK)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_JOYSTICK_TOOLTIP);
    this.currentAxis = this.getFieldValue('NPIN');
  },
  getPins: function () { return ['NPIN2']; },
  component: 'joystick',
  onchange: function () {
    try {
      const axis = this.getFieldValue('NPIN');
      if (this.currentAxis !== axis) {
        this.currentAxis = axis;
        this.removeInput('PINS');
        const pinType = axis === 'a' ? 'digital' : 'analog';
        this.appendDummyInput('PINS')
          .appendField(Blockly.Msg.LANG_ENTRADAS_JOYSTICK)
          .appendField(new Blockly.FieldDropdown(
            () => Blockly.getMainWorkspace().getHardwarePinsCombo(pinType, `${this.component}_NPIN2`),
          ), 'NPIN2');
      }
    } catch (e) { /* el swap de pin ignora errores de API */ }
  },
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_PULSO = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Pulso.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_PULSO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_PULSO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'pulso',
};

Blockly.Blocks.ARDUINOUNO_ENTRADAS_MAGNETICO = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Magnetico2.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_MAGNETICO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_MAGNETICO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'pulso',
};

// ------------------------------ PANTALLA / LCD ------------------------------

Blockly.Blocks.ARDUINOUNO_lcd_educabot = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/LCD.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_I2C);
    this.appendValueInput('NAME');
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_LCD_ADVANCED_ROWS)
      .appendField(new Blockly.FieldDropdown([
        ['0', '0'],
        ['1', '1'],
      ]), 'CURSOR_ROW')
      .appendField(Blockly.Msg.LANG_LCD_ADVANCED_COLUMNS_I2C)
      .appendField(new Blockly.FieldDropdown([
        ['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'],
        ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'],
        ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'],
      ]), 'CURSOR_COLUMN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_DIRECCION_I2C)
      .appendField(new Blockly.FieldTextInput('0x27'), 'LCD_DIRECCION');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_DEF_TOOLTIP);
  },
  component: 'lcd',
};

Blockly.Blocks.ARDUINOUNO_lcd_setBacklight = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/LCD.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
      ]), 'STATE')
      .appendField(Blockly.Msg.LANG_LCD_SETBACKLIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_DIRECCION_I2C_2)
      .appendField(new Blockly.FieldTextInput('0x27'), 'LCD_DIRECCION');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_SETBACKLIGHT_TOOLTIP);
  },
};

Blockly.Blocks.ARDUINOUNO_lcd_clear = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/LCD.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_CLEAR);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_DIRECCION_I2C_2)
      .appendField(new Blockly.FieldTextInput('0x27'), 'LCD_DIRECCION');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_CLEAR_TOOLTIP);
  },
};

// ------------------------------ MOTORES -------------------------------------

Blockly.Blocks.ARDUINOUNO_servo_move = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Servo.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SERVO_MOVE_DEGREES);
    this.appendValueInput('angulo');
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_SERVO_MOVE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_MOVE_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};

Blockly.Blocks.ARDUINOUNO_servo_read = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Servo.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_SERVO_READ)
      .appendField(Blockly.Msg.LANG_SERVO_READ_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, 'Boolean');
    this.setTooltip(Blockly.Msg.LANG_SERVO_CONT_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};

Blockly.Blocks.ARDUINOUNO_SALIDAS_motor = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/MotorDC.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .appendField(new Blockly.FieldDropdown([
        ['Girar', '4'],
        ['Frenar', '6'],
      ]), 'NPIN1');
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'motordc',
};

Blockly.Blocks.ARDUINOUNO_SALIDAS_motor_pwm = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/MotorDC.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN1')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_PIN_PWM)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendValueInput('DATOIN')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_SPEED);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'motordc',
};

Blockly.Blocks.ARDUINOUNO_SALIDAS_motor_doble = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/MotorDC.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN2')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar hacia la derecha', '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar hacia la izquierda', '4'],
        [Blockly.Msg.LANG_MOTOR_TURN_BRAKE || 'Frenar', '6'],
      ]), 'NPIN2');
    this.appendDummyInput('PIN0')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN0`),
      ), 'NPIN0');
    this.appendDummyInput('PIN1')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN1`),
      ), 'NPIN1');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN0', 'NPIN1']; },
  component: 'motordcdouble',
};

Blockly.Blocks.ARDUINOUNO_SALIDAS_motor_doble_pwm = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/MotorDC.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN2')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar hacia la derecha', '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar hacia la izquierda', '4'],
        [Blockly.Msg.LANG_MOTOR_TURN_BRAKE || 'Frenar', '6'],
      ]), 'NPIN2');
    this.appendDummyInput('PIN0')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_NPIN0`),
      ), 'NPIN0');
    this.appendDummyInput('PIN1')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_NPIN1`),
      ), 'NPIN1');
    this.appendValueInput('DATOIN')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_SPEED);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN0', 'NPIN1']; },
  component: 'motordcdouble',
};
